import axios from "axios";

export const getSoftwareLevels = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_software_levels"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
